<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import UpdateEventSubParticipants from '@mobile/ActionQueue/Actions/Event/UpdateEventSubParticipants'

import QueueAction from './QueueAction.vue'

export default defineComponent({
  components: { QueueAction },
  props: {
    action: {
      type: Object as PropType<UpdateEventSubParticipants>,
      required: true,
    },
  },
  setup(props) {
    const info = computed(() => JSON.stringify(props.action.dto, undefined, 2))

    return { info }
  },
})
</script>

<template>
  <QueueAction
    :action
    :actionInformation="'Update event sub-participants'"
  >
    <template #infoPanel>
      {{ info }}
    </template>
  </QueueAction>
</template>
